import React from 'react'
import { Icon, Tag } from 'antd'
import ReactQuill from 'react-quill';

// Modules to React Quil fields
let modules = {
	toolbar: [
		[{ 'header': [1, 2, 3, false] }],
		['bold', 'italic', 'underline', 'link', { 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
		[{ 'list': 'ordered' }, { 'list': 'bullet' }]
	],
}
let formats = [
	'header',
	'bold', 'italic', 'underline', 'link', 'align',
	'list', 'bullet'
]

export default {
	"fields": [
		[
			{
				type: 'select',
				key: 'performance_level',
				title: 'Perfis de Desempenho',
				options: [],
				optionConfig: { name: 'performance' },
				loaded: false,
				colSize: 12,
				'element-attr': {
					required: true,
					mode: 'multiple'
				}
			},
		], [
			{
				title: 'Observação fixa',
				key: 'door_display_obs',
				type: 'render',
				render: (state, module, node) => {
					return (
						<ReactQuill
							value={state.formRef.door_display_obs || { "text": "<strong>Material não incluso:</strong>" }}
							modules={modules}
							formats={formats}
							onChange={value => {
								module.updateRefValue(node, value, 'door_display_obs')
							}}
						/>
					)
				},
				beforeSave: (module, parseObject, node) => {
					parseObject.set('door_display_obs', module.state.formRef.door_display_obs)
					return true;
				}
			}
		]
	],
	submit: {
		collection: "DoorDisplayConfigs"
	},
	className: "config-component",
	schema: [
		{
			title: 'Perfis de Desempenho',
			key: 'performance_level',
			dataIndex: 'performance_level',
			render: v => {
				return (v || [])
					.map((performance, i) => <Tag key={i}>{performance}</Tag>)
			}
		},
		{
			title: "Observação fixa",
			key: "door_display_obs",
			dataIndex: "door_display_obs",
			render: obs => {
				return <div dangerouslySetInnerHTML={{ __html: obs }} />
			}
		},
	],
	"title-navigation": <div><Icon type="border-outer" /> Visor</div>,
	"title-module": "Visor",
	"module": "DoorDisplayConfigs",
	"router-base": "/panel/visor-configs"
}